import {Link} from "react-router-dom"
import {getTimeFromNow} from "../../../functions/time"
import {useRepoList} from "../../../hooks/useRepoList"
import {ProfileDB} from "../../../models/ProfileDB.model"
import styles from "./index.module.scss"

interface HomeRepoListingProps {
  profile: ProfileDB
}

export const HomeRepoListing = (props: HomeRepoListingProps) => {
  const {repos} = useRepoList(props.profile)
  const profileOrbitId = props.profile.address.root
  const profilePubKey = props.profile.address.path

  return (
    <div className={styles.RepoListing}>
      {
        repos.slice(0, 5).map(repo => {
          const url = `/repos/${repo.address.replace("/orbitdb", `${profileOrbitId}/${profilePubKey}`)}/codes`
          return (
            <Link className={styles.RepoCard} key={repo.id} to={url}>
              <div className={styles.RepoName}>{repo.name}</div>
              <div className={styles.RepoDescription}>{repo.description}</div>
              <div className={styles.CreateAt}>Created {getTimeFromNow(repo.createAt, true)}</div>
            </Link>
          )
        })
      }
    </div>
  )
}
